
import { defineComponent } from "vue";
import consts from "@/const/const";

export default defineComponent({
  name: "AppSearch",
  props: {
    searchResults: {
      type: Object,
    },
    lectureParam: String,
  },
  data() {
    return {
      consts: consts,
    };
  },
  methods: {
    // 全角英数記号半角変換
    abc123ToHAN(strVal: string): string {
      var han = strVal.replace(/[！-～]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
      });
      // 文字コードシフトで対応できない文字の変換
      return han
        .replace(/”/g, '"')
        .replace(/’/g, "'")
        .replace(/‘/g, "`")
        .replace(/￥/g, "\\")
        .replace(/〜/g, "~")
        .replace(/\u3000/g, " ");
    },
  },
});
